import { IconProps } from "@/components/shared/Icon"

export enum Weekday {
   SUNDAY = "SUNDAY",
   MONDAY = "MONDAY",
   TUESDAY = "TUESDAY",
   WEDNESDAY = "WEDNESDAY",
   THURSDAY = "THURSDAY",
   FRIDAY = "FRIDAY",
   SATURDAY = "SATURDAY",
}

export interface OpenCellSchedule {
   id: string
   levelId: string
   startTime: string
   endTime: string
   weekdays: Weekday[]
   windowIds: Partial<Record<Weekday, string>>
}

export interface OpenCellScheduleRow extends OpenCellSchedule {
   levelName: string
   levelIcon?: IconProps["name"]
}

export interface DraftCellRendererProps {
   draft: OpenCellScheduleRow | null
   onDraftChange: (changes: Partial<OpenCellScheduleRow>) => void
}
